import React from 'react';
import Masonry from 'react-masonry-css';
import OrderCard from '../OrderCard';

function OrdersCanceled({ baskets, kdsViewMode, kds, kds_index }) {
  const breakpointColumnsObj = {
    default: kdsViewMode,
    1100: 3,
    700: 2,
    500: 1,
  };

  return (
    <Masonry
      breakpointCols={breakpointColumnsObj}
      className="my-masonry-grid"
      columnClassName="my-masonry-grid_column"
    >
      {baskets?.length > 0 &&
        baskets
          ?.filter((item) => item.status === 'canceled')
          .map((item) => (
            <OrderCard
              item={item}
              key={item.id}
              kds={kds}
              kds_index={kds_index}
            />
          ))}
    </Masonry>
  );
}

export default OrdersCanceled;
